import styled from 'styled-components';

export const Container = styled.div`
   display: flex;
   width: 400px;
   max-height: 500px;
   padding: .2rem 1rem;
   overflow-x: hidden;
   overflow-y: scroll;

   &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
   }
   &::-webkit-scrollbar-thumb{
      background-color: rgb(0, 0, 0,0.1);
   }

   .ic-s{
      color: #07bc0c
   }
   .ic-e{
      color: #e74c3c
   }
`;
export const Contacts = styled.ul`
   display: flex;
   width: 100%;
   height: 100%;
   gap: 1rem;
   flex-direction: column;
`;
export const Contact = styled.li`
   display: flex;
   width: 100%;
   padding: .5rem;
   border-radius: 10px;
   flex-direction: column;
   background-color: #f6f6f6;
   > div:nth-child(1) {
      display: flex;
      gap: .75rem;
      align-items: center;
      > span {
         font-weight: 600;
         font-size: 1rem;
         text-align: left;
         overflow: hidden;
         text-overflow: ellipsis;
         white-space: nowrap;
      }
   }
   > ul {
      display: flex;
      gap: .5rem;
      margin-top: .5rem;
      justify-content: center;
      align-items: center;
      flex-direction: column;
   }
`;
export const CardPhone = styled.li`
   display: flex;
   width: 100%;
   height: 3rem;
   gap: .5rem;
   padding: .5rem;
   align-items: center;
   justify-content: space-between;
   border-radius: 6px;
   background-color: #ffffff;
   > div {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: .5rem;
      > svg {
         opacity: 0.5;
      }
      > span {
         cursor: text;
         user-select: all;
      }
   }
`;
export const ButtonAddContact = styled.button`
   outline: none;
   border: none;
   display: flex;
   justify-content: center;
   align-items: center;
   background-color: rgb(29, 134, 255); 
   border-radius: 4px;
   color: #ffffff;
   padding: .3rem;
   font-weight: bolder;
   cursor: pointer;
   box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);
`;
export const Loader = styled.div`
   border: 2px solid rgb(29, 134, 255); 
   border-top: 2px solid #0000; 
   border-radius: 50%;
   width: 15px;
   height: 15px;
   animation: spin 1s linear infinite;
@keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
export const ContactName = styled.div`
   display: flex;
   width: 500px;
   height: 4rem;
   justify-content: space-between;
   align-items: center;
   background: #ffffff;
   border-radius: 8px;
   > div {
      display: flex;
      width: calc(100% - 3rem);
      height: 2.5rem;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      padding: .5rem;
      gap: .1rem;
      background-color: #f6f6f6;
      > input {
         border: none;
         outline: none;
         width: 100%;
         height: 100%;
         background: transparent;
      }
      > .ed-n {
         cursor: pointer;
         opacity: 0.5;
         &:hover{
            opacity: 1;
         }
      }
   }
   > span {
      display: flex;
      width: 2.5rem;
      height: 2.5rem;
      justify-content: center;
      align-items: center;
      background-color: rgb(29, 134, 255);
      color: #ffffff;
      border-radius: 50%;
      cursor: pointer;
      box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);
   }
`;

export const Icon = styled.span`
   display: flex;
   width: 1.5rem;
   height: 1.5rem;
   justify-content: center;
   align-items: center;
`;